import { render, staticRenderFns } from "./ViewEntitiesByRole.vue?vue&type=template&id=70d209f5"
import script from "./ViewEntitiesByRole.vue?vue&type=script&lang=js"
export * from "./ViewEntitiesByRole.vue?vue&type=script&lang=js"
import style0 from "./ViewEntitiesByRole.vue?vue&type=style&index=0&id=70d209f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports